<template>
    <div @click="$emit('refreshMap')" class="col-md-12 mb-4 profile-map-wrapper" v-if="showMap || showOutcallLocation">
        <div class="h-100 accordion-map container-box">
            <div class="container-box-title">{{ translate.home.location }}</div>
            <div class="container-box-content" id="profile-page-location" :class="{'full': showOutcallLocation && showMap}">
                <div v-if="showMap" id="map" ref="map"></div>
                <outcall-location-in-profile-component v-if="showOutcallLocation" :user="user" />
            </div>
        </div>
    </div>
</template>
<script>
import OutcallLocationInProfileComponent
    from "@/components/users/profile/partials/OutcallLocationInProfileComponent.vue";

export default {
    components: {OutcallLocationInProfileComponent},
    computed: {
        ...mapState(['translate'])
    },
    props: ['user', 'showOutcallLocation', 'showMap'],
}
</script>
